import { ScrollSlider } from '../classes/ScrollSlider';

document.querySelectorAll('.scroll-slider').forEach((slider) => new ScrollSlider(slider as HTMLElement));
